import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
import { Configuration } from '@portfolio-manager/sdk';
const ApiConfigurationContext = createContext(null);
export function ApiConfigurationProvider({ configuration, children }) {
    const value = useMemo(() => (configuration instanceof Configuration ? configuration : new Configuration(configuration)), [configuration]);
    return _jsx(ApiConfigurationContext.Provider, { value: value, children: children });
}
export function useApiConfiguration() {
    const configuration = useContext(ApiConfigurationContext);
    if (configuration === null) {
        throw new Error('useApiConfiguration must be used within a <ApiConfigurationProvider>.');
    }
    return configuration;
}
//# sourceMappingURL=api-configuration-context.js.map